import React from 'react';

import CKEditor from 'ckeditor4-react';

import { CkEditorNewlineTrimmer } from '../util/ckeditor-newline-trimmer';

type Props = any;

type State = {
  hasUncaughtError: boolean;
};

/**
 * Wrapper around CKEditor
 * @see https://ckeditor.com/docs/ckeditor4/latest/api/CKEDITOR.html
 */
class UiRichTextEditorComponent extends React.PureComponent<Props, State> {
  static getDerivedStateFromError() {
    // Update state so the next render will make the CkEditor disappear
    return { hasUncaughtError: true };
  }

  state: State = {
    hasUncaughtError: false,
  };

  componentDidCatch() {
    // No-op, just want to prevent the app from crashing if
    // CKEditor is struggling - we've seen a lot of permission
    // denied errors from IE
  }

  render() {
    const { injectCKEditorLineEndings } = this.props;
    const { hasUncaughtError } = this.state;
    if (hasUncaughtError) {
      return null;
    }

    return (
      <CKEditor
        name={this.props.languageCode}
        ref={this.props.innerRef}
        // https://github.com/ckeditor/ckeditor4-react/issues/57
        onBeforeLoad={(CKEDITOR: any) => {
          CKEDITOR.disableAutoInline = true;
        }}
        onSetData={
          injectCKEditorLineEndings
            ? (event: any) => {
                event.data.dataValue = CkEditorNewlineTrimmer.untrimMessage(event.data.dataValue);
              }
            : undefined
        }
        {...this.props}
      />
    );
  }
}

export const UiRichTextEditor = React.forwardRef((props: any, ref) => (
  <UiRichTextEditorComponent innerRef={ref} {...props} />
));
